import * as React from 'react'
import { Hidden } from '@mui/material'

interface ISchoolAuthComponentWrapperProps {
  school_details: any
  authComponent: React.ReactNode
}

const LargeScreenComponent = (props: ISchoolAuthComponentWrapperProps) => {
  const { background_image } = props.school_details

  return (
    <div
      style={{
        display: 'flex',
        // flexWrap: "wrap",
        width: '100%',
      }}
    >
      <div
        style={{
          // position: "fixed",
          // bottom: "0px",
          // top: "0px",
          // right: "0px",
          width: '60%',
          display: 'flex',
          minHeight: '500px',
          alignItems: 'center',
          backgroundImage: background_image
            ? `linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.3)), url('${background_image}')`
            : "linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.3)), url('/static/img/bg_img_3.jpeg')",
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div
        style={{
          width: '40vw',
          minWidth: '500px',
          overflowY: 'auto',
          maxHeight: '100vh',
        }}
      >
        {props.authComponent}
      </div>
    </div>
  )
}

const SmallScreenComponent = (props: ISchoolAuthComponentWrapperProps) => {
  return (
    <div>
      <div
        style={{
          // display: "flex",
          // flexWrap: "wrap",
          width: '100%',
          backgroundColor: '#fff',
        }}
      >
        {props.authComponent}
      </div>
    </div>
  )
}

const SchoolAuthComponentWrapper = (
  props: ISchoolAuthComponentWrapperProps,
) => {
  return (
    <div style={{ backgroundColor: '#fafafa' }}>
      <Hidden smDown={true}>
        <LargeScreenComponent {...props} />
      </Hidden>
      <Hidden smUp={true}>
        <SmallScreenComponent {...props} />
      </Hidden>
    </div>
  )
}

export default SchoolAuthComponentWrapper
